export class Mailer {
    Id: number;
    Name: string;
    MailerTemplateId: number;
    TemplateBody: string;
    TemplateFooter: string;
    TemplateSubject: string;
    TemplateImageUrl: string;
}